<template>
  <div>
    <div class="print">
      <el-button
        @click="printReport"
        type="primary"
        size="medium"
        icon="el-icon-printer"
        >打印</el-button
      >
    </div>
    <div class="wrap">
      <div class="body">
        <el-card>
          <div id="printarea">
            <SysHead></SysHead>
            <OverView></OverView>
            <ItemTitle title="综合报告"></ItemTitle>
            <SynthesisReport></SynthesisReport>

            <StateReport :list="states"></StateReport>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import print from "@/common/print.js";
import SysHead from "./head.vue";
import OverView from "./overview.vue";
import ItemTitle from "./title.vue";
import SynthesisReport from "./synthesis/index.vue";
import StateReport from "./state/index.vue";
export default {
  components: {
    SysHead,
    OverView,
    ItemTitle,
    SynthesisReport,
    StateReport,
  },
  data() {
    return {
      states: [
        {
          key: "jkReportHistories",
          name: "健康评估",
        },
        {
          key: "qxReportHistories",
          name: "情绪评估",
        },
        {
          key: "plReportHistories",
          name: "疲劳评估",
        },
        {
          key: "jsReportHistories",
          name: "精神评估",
        },
        {
          key: "smReportHistories",
          name: "睡眠评估",
        },
      ],
    };
  },
  created() {
    let query = {
      ...this.$route.query,
    };
    this.$store.dispatch("reportData", query);
  },
  methods: {
    printReport() {
      this.$store.commit("setPrinting", true);
      this.$nextTick(() => {
        let that = this;
        print({
          printable: "printarea",
          type: "html",
          targetStyles: ["*"],
          css: [
            "https://cdn.bootcss.com/element-ui/2.15.8/theme-chalk/index.css",
          ],
          onLoadingEnd() {
            that.$store.commit("setPrinting", false);
          },
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.print {
  display: flex;
  flex-direction: row-reverse;
  margin: 10px;
}
.wrap {
  background-color: rgb(244, 249, 253);
  .body {
    padding: 10px;
  }
}
</style>